exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".additional-classifications-actions-renderer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  padding: 16px;\n  height: 64px;\n}\n", ""]);

// exports
